import { formatNumber, toMoney } from '@utils/Format'
import { resolvePosicaoPlTotal } from '@modules/consolidator/utils/posicao-pl-fallback/posicao-pl-fallback'
import { formatInstitutionDistribution } from '@modules/consolidator/utils/format-institution-distribution/format-institution-distribution'

const PORTFOLIO_PERIOD_KEYS = { total: 'inicio', ano: 'ano', mes: 'mes' }
const BENCHMARK_PERIOD_KEYS = {
  total: 'rent_inicio',
  ano: 'rent_ano',
  mes: 'rent_mes',
}

export const formatWelcomeCardData = (walletAnalysis) => {
  if (!walletAnalysis) return null
  return {
    totalInvestido: buildTotalInvestido(walletAnalysis),
    distribuicao: buildDistribuicao(walletAnalysis),
    rentabilidade: buildRentabilidade(walletAnalysis),
  }
}

const buildTotalInvestido = (walletAnalysis) => {
  const plTotal = resolvePosicaoPlTotal(walletAnalysis)
  if (!Number.isFinite(plTotal)) return ''
  const currency = walletAnalysis.currency === 'USD' ? 'dol' : 'real'
  return toMoney(plTotal, 2, currency)
}

const buildDistribuicao = (walletAnalysis) => {
  const distribution = formatInstitutionDistribution(walletAnalysis)
  return Object.values(distribution)
    .sort((first, second) => second.value - first.value)
    .map((institution) => ({
      instituicao: institution.name,
      percentual: formatNumber(institution.percent, 2),
    }))
}

const buildRentabilidade = (walletAnalysis) => {
  const emptyRentabilidade = { total: '', ano: '', mes: '' }
  const statistics = walletAnalysis.portfolio_statistics
  if (!statistics) return emptyRentabilidade
  const benchmarkMeta = walletAnalysis.cliente_benchmark_meta
  const isTimesLogic =
    !benchmarkMeta || (benchmarkMeta.logic || 'times') === 'times'
  const benchmarkStatistics =
    (statistics.benchmarks_statistics &&
      statistics.benchmarks_statistics.cliente_benchmark) ||
    {}
  const rentabilidade = {}
  Object.keys(PORTFOLIO_PERIOD_KEYS).forEach((period) => {
    rentabilidade[period] = buildRentabilidadeValue({
      portfolioReturn: statistics[PORTFOLIO_PERIOD_KEYS[period]],
      benchmarkReturn: benchmarkStatistics[BENCHMARK_PERIOD_KEYS[period]],
      isTimesLogic,
    })
  })
  return rentabilidade
}

const buildRentabilidadeValue = ({
  portfolioReturn,
  benchmarkReturn,
  isTimesLogic,
}) => {
  if (!Number.isFinite(portfolioReturn)) return ''
  if (isTimesLogic) {
    if (!Number.isFinite(benchmarkReturn) || benchmarkReturn === 0) return ''
    return formatNumber((portfolioReturn / benchmarkReturn) * 100, 2)
  }
  if (!Number.isFinite(benchmarkReturn)) return ''
  return formatNumber((portfolioReturn - benchmarkReturn) * 100, 2)
}
